import { instance as axios } from "@/store/_AXIOS";
import {_TOKEN, _DECODE} from "@/store/_JWT"

const TABLE = '/tipo_utilizador/';

// initial state
const state = {
    data: []
}

// getters
const getters = {
    getAll:(state)=>{
        return state.data
    },
    getById: (state) => (id) => {
        if(!id || state.data.length==0 || typeof state.data.find((el) => { return el.id_tipo_utilizador == id }) == 'undefined') return '-';
        return state.data.find((el) => { return el.id_tipo_utilizador == id }).nome;
    }
}

// actions
const actions = {

    get({ commit }, params) {
        return axios
            .get(TABLE)
            .then(res => {
                _DECODE(res.data.data).then((r)=>{
                    if(r) commit('setData', r)
                    else commit('setData', null)
                });
            })
            .catch(err => {
                commit('setData', null)
            });
    },

}

// mutations
const mutations = {
    setData(state, data) {
        state.data = data ? data : [];
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}